import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Headset } from "lucide-react";
import { useLeftSidebar } from "@/components/ui/sidebar";
import { isModifiedClick } from "@/lib/link-utils";
import { useTicketStats } from "@/features/support";
import { useSidebarNavigation } from "./hooks/use-sidebar-navigation";
import { SidebarTooltip } from "./SidebarTooltip";
import mixpanel from "mixpanel-browser";

const ICON_SIZE = 18;

export default function SupportButton() {
  const { t } = useTranslation();
  const { open: isSidebarOpen } = useLeftSidebar();
  const { supportPath, onSidebarLinkClick } = useSidebarNavigation();

  // Admin: cevap bekleyen destek talebi sayısı (admin değilse sorgu çalışmaz)
  const { stats } = useTicketStats();
  const unreadCount = stats?.unread ?? 0;

  return (
    <SidebarTooltip label={t("common.support")} disabled={isSidebarOpen}>
      <Link
        to={supportPath}
        onClick={(e) => {
          // Analytics her tıklamada çalışır (yeni sekmede açılsa da kullanıcı tıkladı);
          // sidebar kapatma ise yalnızca mevcut sayfada gezinirken anlamlı.
          mixpanel.track("Support Button Clicked", {
            type: "support_page_clicked",
          });
          window.netmera.push((api) => {
            api.sendEvent({
              code: "pparn",
            });
          });
          if (isModifiedClick(e)) return;
          onSidebarLinkClick();
        }}
        className={`w-full flex items-center py-[8px] rounded-[6px] hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors focus:outline-none ${
          isSidebarOpen ? "px-3 gap-3" : "px-2 justify-center"
        }`}
      >
        <div className="relative size-5 flex items-center justify-center shrink-0">
          <Headset size={ICON_SIZE} className="text-text-quaternary" />
          {/* Sidebar kapalıyken sayı yerine nokta */}
          {!isSidebarOpen && unreadCount > 0 && (
            <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-module-accent" />
          )}
        </div>
        {isSidebarOpen && (
          <>
            <p className="font-semibold text-text-sm text-text-primary dark:text-gray-100">
              {t("common.support")}
            </p>
            {unreadCount > 0 && (
              <span className="ml-auto rounded-full bg-module-accent px-1.5 py-0.5 text-[10px] font-semibold leading-none text-module-accent-foreground">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </>
        )}
      </Link>
    </SidebarTooltip>
  );
}
